import { render, staticRenderFns } from "./UmDbCardList.vue?vue&type=template&id=7525a6be&"
import script from "./UmDbCardList.vue?vue&type=script&lang=js&"
export * from "./UmDbCardList.vue?vue&type=script&lang=js&"
import style0 from "./UmDbCardList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports